import { ApiError } from 'core/errors/ApiError';

export function unwrapEnvelope(payload, fallbackMessage = 'Request failed') {
  if (payload == null || typeof payload !== 'object') {
    throw new ApiError({
      status: 0,
      message: fallbackMessage,
      payload,
    });
  }

  if (payload.success === false) {
    throw new ApiError({
      status: 0,
      message: payload.message || fallbackMessage,
      errors: payload.errors || {},
      payload,
    });
  }

  if (Object.prototype.hasOwnProperty.call(payload, 'data')) {
    return payload.data;
  }

  return payload;
}

export function captureRevision(data, setRevision) {
  if (!data || typeof data !== 'object' || typeof setRevision !== 'function') {
    return data;
  }
  if (typeof data.revision === 'number') {
    setRevision(data.revision);
  }
  return data;
}
